import { useContext } from 'react'
import { Context } from './MainContext'
export const useMainContext = () => useContext(Context)
export default useMainContext